/**
 * Shared layout for scenario list + map split (ScenarioList page, Facility Scenarios tab).
 * Must match `.box` in ScenarioList.module.css / FacilityView.module.css: left + width.
 * Also used as left-panel inset for Robot detail / Mission Control geo map focus.
 */
export const SCENARIO_MAP_COLUMN_INSET_LEFT_PX = 22 + 560

/** Alias: geographic map padding when a left sidebar covers the map (RobotView, StationView, MissionControl). */
export const GEO_MAP_LEFT_PANEL_INSET_PX = SCENARIO_MAP_COLUMN_INSET_LEFT_PX

/** GS map preview × — below header controls (ScenarioList: dropdown + search; Facility: title only). */
export const SCENARIO_GS_MAP_PREVIEW_CLOSE_TOP_PX = 120
